import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import {
    useGetNetSuiteExpensesMatchingSuggestions,
    useGetNetSuiteItemsMatchingSuggestions,
} from 'shared/data/webApp/v2';

export const useAvailableMatchingLines = (
    request: selectors.types.NetSuiteBillExpandedRequest,
    lineNumber: number | undefined,
    lineType: domain.NetSuiteMatchingLineType | undefined
) => {
    const { data: netSuiteItemsMatchingSuggestions, isFetching: isFetchingNetSuiteItemsMatchingSuggestions } =
        useGetNetSuiteItemsMatchingSuggestions(
            {
                path: {
                    companyId: request.companyId,
                },
                query: {
                    vendorBillRequestId: request.id,
                    vendorBillLineNumber: lineNumber,
                },
            },
            { enabled: lineType === domain.NetSuiteMatchingLineType.Item }
        );

    const { data: netSuiteExpensesMatchingSuggestions, isFetching: isFetchingNetSuiteExpensesMatchingSuggestions } =
        useGetNetSuiteExpensesMatchingSuggestions(
            {
                path: {
                    companyId: request.companyId,
                },
                query: {
                    vendorBillRequestId: request.id,
                    vendorBillLineNumber: lineNumber,
                },
            },
            { enabled: lineType === domain.NetSuiteMatchingLineType.Expense }
        );

    return {
        suggestions: netSuiteItemsMatchingSuggestions || netSuiteExpensesMatchingSuggestions,
        isFetching: isFetchingNetSuiteItemsMatchingSuggestions || isFetchingNetSuiteExpensesMatchingSuggestions,
    };
};
